export default {
  target: null as any,
  preview: null as any,
  GetSlideSize() {
    const width = this.target.MainViewProxy.GetSlideViewWidth();
    const height = this.target.MainViewProxy.GetSlideViewHeight();
    return {
      width,
      height,
    };
  },
  GetSlide(): any {
    // return this.target.$S.get_$2Y();
    return this.target.$Q.get_$2b();
  },
  GotoStep(slide: number) {
    if (!this.target) {
      return;
    }
    try {
      const n = this.GetSlide();
      // n.$1Vz(slide, 0, 0);
      n.$1Tw(slide, 0, 0);
    } catch (e) {
      console.log(e);
    }
  },
  GetSlideCount(): number {
    if (!this.target) return 0;
    try {
      const p = this.GetSlide();
      // return p.$17E();
      return p.$15i();
    } catch (e) {
      console.log(e);
      return 0;
    }
  },
  GetCurrentIndex(): number {
    if (!this.target) return 0;
    try {
      return this.target.MainViewProxy.GetCurrentSlideIndex();
    } catch (e) {
      console.log(e);
      return 0;
    }
  },
  GetSlidePreviewImage(width?: number, height?: number): string {
    if (!this.target) return "";
    return this.target.MainViewProxy.GetSlidePreviewImage(width, height);
  },
  NextStep() {
    if (!this.target) return;
    try {
      const n = this.GetSlide();
      // return n.$1aw();
      return n.$1Yd();
    } catch (e) {
      console.log(e);
    }
  },
  PrevStep() {
    if (!this.target) return;
    try {
      const n = this.GetSlide();
      // return n.$1b0();
      return n.$1Yh();
    } catch (e) {
      console.log(e);
    }
  },
  NextSlide() {
    if (!this.target) return;
    try {
      const n = this.GetSlide();
      // return n.$1av();
      return n.$1Yc();
    } catch (e) {
      console.log(e);
    }
  },
  PrevSlide() {
    if (!this.target) return;
    try {
      const n = this.GetSlide();
      // return n.$1az();
      return n.$1Yg();
    } catch (e) {
      console.log(e);
    }
  },
};

export enum FileType {
  PPT, DOC, MEDIA
}

export const getFileExtensions = (url: string) => {
  const urlArr = url.split('.');
  return urlArr[urlArr.length - 1]
}

export const getFileTypeBySuffix = (extensions: string) => {
  let type;
  switch (extensions) {
    case "ppt":
    case "pptx":
      type = FileType.PPT;
      break;
    case "doc":
    case "docx":
    case "pdf":
      type = FileType.DOC;
      break;
    case "mp3":
    case "mp4":
      type = FileType.MEDIA;
      break;
    default:
      type = -1
      console.warn("File Type Unknown");
  }
  return type;
}

export const getFileTypeByExt = (url: string) => {
  const extensions = getFileExtensions(url);
  return getFileTypeBySuffix(extensions)
}